/**
 * OData / HTTP API configuration.
 *
 * When your API base URL is defined, either:
 * - set `REACT_APP_API_BASE_URL` in `.env.local`, or
 * - uncomment `API_BASE_URL` and the matching `return` in `getApiBaseUrl()` below.
 */
// export const API_BASE_URL = 'https://your-api.example.com';

/** OData resource path relative to API root (no leading slash). */
export const MERCHANTS_ODATA_PATH = 'odata/MerchantOData';

export const COMPANY_ODATA_PATH = 'odata/CompanyOData';

export function getApiBaseUrl(): string | null {
  // Uncomment together with `API_BASE_URL` above:
  // return API_BASE_URL.replace(/\/$/, '');

  const env = process.env.REACT_APP_API_BASE_URL?.trim();
  if (env) {
    return env.replace(/\/$/, '');
  }
  return null;
}

/**
 * Full URL to the Merchants OData entity set for Syncfusion DataManager.
 * Returns null until REACT_APP_API_BASE_URL is set or API_BASE_URL is uncommented above and wired in.
 */
export function getMerchantsODataUrl(): string | null {
  // Example when using a fixed base from this file:
  // const base = API_BASE_URL.replace(/\/$/, '');
  // return `${base}/${MERCHANTS_ODATA_PATH}`;

  const base = getApiBaseUrl();
  if (!base) {
    return null;
  }
  return `${base}/${MERCHANTS_ODATA_PATH}`;
}

export function getCompanyODataUrl(): string | null {
  const base = getApiBaseUrl();
  if (!base) {
    return null;
  }
  return `${base}/${COMPANY_ODATA_PATH}`;
}

/** Default Stripe dashboard origin used when no override is configured. */
export const DEFAULT_STRIPE_DASHBOARD_URL = 'https://dashboard.stripe.com';

/** Base URL for Stripe dashboard deep links (override via REACT_APP_STRIPE_DASHBOARD_URL). */
export function getStripeDashboardUrl(): string {
  const env = process.env.REACT_APP_STRIPE_DASHBOARD_URL?.trim();
  return (env || DEFAULT_STRIPE_DASHBOARD_URL).replace(/\/$/, '');
}

/** Builds a Stripe dashboard deep link to a customer record. */
export function buildStripeCustomerUrl(stripeCustomerId: string): string {
  return `${getStripeDashboardUrl()}/customers/${encodeURIComponent(stripeCustomerId)}`;
}

/** Base URL of the merchant/3PL frontend app (triplicity-frontend), used for impersonation handoff. */
export function getTriplicityFrontendUrl(): string | null {
  const env = process.env.REACT_APP_TRIPLICITY_FRONTEND_URL?.trim();
  if (!env) {
    return null;
  }
  return env.replace(/\/$/, '');
}
